import { Visibility, VisibilityOff } from '@mui/icons-material';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React, { useState } from 'react';

export type SecureTextFieldType = Omit<TextFieldProps, 'type'> & {
  defaultVisible?: boolean;
};

const SecureTextField: React.FC<SecureTextFieldType> = ({
  defaultVisible = false,
  ...props
}) => {
  const [visible, setVisible] = useState(defaultVisible);

  const handleVisibilityChange = () => {
    setVisible(!visible);
  };

  return (
    <TextField
      type={visible ? 'text' : 'password'}
      {...props}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <InputAdornment
            position="end"
            sx={{ cursor: 'pointer' }}
            onClick={handleVisibilityChange}
          >
            {visible ? <VisibilityOff /> : <Visibility />}
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SecureTextField;
